import { CollectionListStatus } from '@/types'

export interface UpdateCollectionListRequest {
  id: number
  name: string
  nameKana: string
  status: CollectionListStatus
  releaseStartDate: string
  releaseEndDate: string
  unlimitedFlag: boolean
  priority: number | null
  revision: number
  bibliographies: {
    collectionListDetailId: number
    bibliographyRealId: number
    rank: number
  }[]
}

export function UpdateCollectionListRequestToJSON(
  value: UpdateCollectionListRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    name: value.name !== '' ? value.name : undefined,
    name_kana: value.nameKana !== '' ? value.nameKana : undefined,
    status: value.status ?? undefined,
    release_start_date:
      value.releaseStartDate !== '' ? value.releaseStartDate : undefined,
    release_end_date:
      value.releaseEndDate !== '' ? value.releaseEndDate : undefined,
    unlimited_flag: value.unlimitedFlag ?? undefined,
    priority: value.priority ?? undefined, // 0で登録もあり得る
    revision: value.revision !== 0 ? value.revision : undefined,
    bibliographies:
      value.bibliographies.length > 0
        ? value.bibliographies.map(bibliography => {
            return {
              collection_list_detail_id:
                bibliography.collectionListDetailId !== 0
                  ? bibliography.collectionListDetailId
                  : undefined,
              bibliography_real_id:
                bibliography.bibliographyRealId !== 0
                  ? bibliography.bibliographyRealId
                  : undefined,
              rank: bibliography.rank !== 0 ? bibliography.rank : undefined
            }
          })
        : undefined
  }
}
